export const convertTime = (min: number, sec: number) => {
  const safeMin = Number.isFinite(min) ? min : 0;
  const safeSec = Number.isFinite(sec) ? sec : 0;
  return `${safeMin.toString().padStart(2, '0')}:${safeSec.toString().padStart(2, '0')}`;
};
